import {
    CREATEHSN,
    DELETEHSN,
    LISTOFHSN,
    EDITHSN,
    VIEWHSN,
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const createHSN = async (data: object) => {
    const response = await authData.post(CREATEHSN, data);
    return response?.data;
  };
  export const updateHSN = async (data: object) => {
    const response = await authData.put(`${EDITHSN}`, data);
    return response?.data;
  };
  export const listOfHSN = async (data: object) => {
    const response = await authData.post(LISTOFHSN, data);
    return response?.data;
  };
  export const viewHSN = async (id: number) => {
    const response = await authData.post(`${VIEWHSN}${id}`);
    return response?.data;
  };

  export const deleteHSN = async (id: number) => {
    const response = await authData.delete(`${DELETEHSN}${id}`);
    return response?.data;
  };